import React, {useState, useEffect} from 'react';
import {useForm} from 'react-hook-form';
import RNUFormService from "../../../../services/RNUFormService";
import { UE_LOGO} from '../../../../constants'
import moment from "moment";

const TemplatePROHeader = (props)=>{

    const [demInfo, setDemInfo] = useState({name:'', email:''})
    const rnuFormService = new RNUFormService()
    const { register, handleSubmit, watch, errors } = useForm();


    useEffect(()=>{
        setDemInfo(rnuFormService.getUserInfo())
        moment.locale('fr');
    }, [])

    useEffect(()=>{

        rnuFormService.updateUserInfo(demInfo)

    }, [demInfo])

    return (
            <div className={"ue-header-zone"}>
                <table className={"ue-header-table"} style={{"width":"100%"}}>
                    <tbody>
                    <tr>
                        <td className={"text-right"} style={{"width":"71px"}}>
                            <img
                                src={UE_LOGO}
                                alt="ue-logo"
                                width="70"
                                height="100"
                            />
                        </td>
                        <td>
                            <div style={{"minWidth": "200px"}}>
                                <div className={"ue-block-mark"}>
                                    <h2>Urba Earth</h2>
                                    Système d’Information Géographique<br/>
                                    Urbanisme et aménagement du territoire<br/>
                                    <br/>
                                    <div className="adress">
                                        14 rue conventionnel Chiappe<br/>
                                        20 000 Ajaccio<br/>
                                        Courriel : contact@urba-earth.fr<br/>
                                        Web : urba-earth.com<br/>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td className={"text-right"}>
                            <div className={"ue-entity-ref"}>
                                <p>
                                <span className={"ue-font-weight-7"} id={'refDemName'}>{(demInfo.name)?demInfo.name:''}</span><br/>
                                <span id={'refSiren'}>{(demInfo.siren)?demInfo.siren:''}</span><br/>
                                </p>
                                <p>
                                <span id={'refDemAddress'}>{(demInfo.address)?demInfo.address:''}</span><br/>
                                <span id={'refDemCP'}>{(demInfo.cp)?demInfo.cp:''} </span>
                                <span id={'refDemCity'}> {(demInfo.city)?demInfo.city:''}</span><br/>
                                <span id={'refDemPhone'}>{(demInfo.phone)?demInfo.phone:''}</span><br/>
                                <span id={'refDemEmail'}>{(demInfo.email)?demInfo.email:''}</span><br/>
                                </p>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
    )

}



export default TemplatePROHeader
